import {OverlayTrigger, Popover} from "react-bootstrap";
import {useState} from "react";
import {useSelector} from "react-redux";
import {ActionListStyled, ActionsButtonStyled} from "./ActionsButton.styled";

/**
 * @param {{ action: string, label: string }[]} actions
 * @param {(action: string) => void} onAction
 * @param {'bottom' | 'top' | 'start' | 'end'} placement
 * */
export function ActionsButton({ actions, onAction = (action) => void null, placement }) {

    const ltr = useSelector(state => state.common.ltrEnabled);

    const [showPopover, setShowPopover] = useState(false);

    function handleActionClick(action) {
        setShowPopover(false);
        onAction(action);
    }

    function getPlacement() {
        switch (placement) {
          case 'top':
          case 'bottom':
            return placement;
          case 'start':
            return ltr ? 'left' : 'right';
          case 'end':
            return ltr ? 'right' : 'left';
          default:
            return 'bottom';
        }
    }

    return (
        <OverlayTrigger
            rootClose
            show={showPopover}
            onToggle={() => setShowPopover(!showPopover)}
            trigger="click"
            placement={getPlacement()}
            overlay={(
                <ActionListStyled ltr={ltr}>
                    <Popover.Body>
                        {actions.map(a => (<button key={a.action} type="button" className='link' onClick={() => handleActionClick(a.action)}>{a.label}</button>))}
                    </Popover.Body>
                </ActionListStyled>
            )
        }>
            <ActionsButtonStyled className='actions-button'>
                {/* the solution with .dot divs were implemented istead of '⋮' character for more flexible and transparent way of stylyng dots */}
                <div className='dot'></div>
                <div className='dot'></div>
                <div className='dot'></div>
            </ActionsButtonStyled>
        </OverlayTrigger>
    );
}
